import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useSelector } from "react-redux";
import store from "src/storeWire";
import System from "../../helper/system";
import { useAxiosIndicatorCheck } from "../../store/hook/useAxiosIndicatorCheck";
import liveAuth from 'src/helper/liveAuth';
import AxiosSingletonLoader from 'src/component/Global/AxiosSingletonLoader';
import produceClone from "../../helper/produceClone";
import { __remove, __set } from 'src/store/axios_indicator';
import { SET_ADD_CART_DATA } from 'src/store/slice/model/Cart';
import { useCartStore } from 'src/hooks/cart';
import { useProductInventoryPriceStore } from 'src/hooks/productInventoryPrice';
import Constants from 'src/helper/Constants';
import { useProductStore } from 'src/hooks/product';
import useReduxState from 'src/hooks/useReduxState';
import HelperAdobeEvent from "src/support/HelperAdobeEvent";
import HelperAnalyticsEvent from 'src/support/HelperAnalyticsEvent';

const AddToCart = (props) => {
    const addToCartButtonRef = useRef(null);
    const { single_product, isCompactView, isCompactViewHide, product_detail, isHideAddToCart, isHideClickToQuote, single_product_inventory, special_class_for_add_to_quote, selected_cpn, single_product_pricing_list, isFrom, do_not_display_add_to_cart_button = false, isObsoleteProduct = false, isFromManualCart = false } = props;
    const [disabled_add_to_cart_button, set_disabled_add_to_cart_button] = useState(false);
    const [{ CART_BEFORE_TO_SEND_SERVER, ADD_CART_DATA }, { get_display_status_button, get_Validate_Cart_From_Server }, { ADD_TO_CART }] = useCartStore();
    const [{ }, { get_inventory_by_distributor }, { }] = useProductInventoryPriceStore();
    const [{ }, { get_end_customer_by_cpn }, { }] = useProductStore();
    const [addToCartSingleClick, setAddToCartSingleClick] = useReduxState({}, 'addToCartSingleClick')
    const [addToCartClick, setAddToCartClick] = useReduxState({}, 'addToCartClick')
    const add_cart_data = ADD_CART_DATA;

    const [load, setLoad] = useState(false);
    const ItemNumber = single_product.ItemNumber;
    const [disableCart, setDisableCart] = useState(0);
    const [__check] = useAxiosIndicatorCheck();
    const orderBlock = System.avUserInfoData.orderBlock;
    const { systemModules: { CART, PDP }, currencyType: { USD } } = Constants

    useEffect(() => {
        async function fetchHere() {
            let status = false;

            const _product = CART_BEFORE_TO_SEND_SERVER[ItemNumber];

            if (_product && _product.invalid_quantity) {
                status = true;
            }
            if (isObsoleteProduct) {
                status = true;
            }

            set_disabled_add_to_cart_button(status)
        }

        fetchHere()
    }, [CART_BEFORE_TO_SEND_SERVER[ItemNumber], isObsoleteProduct])

    useEffect(() => {
        if (!add_cart_data) {
            setLoad(add_cart_data)
            __remove('CART_API_CALL');
        }
        if (add_cart_data && !load) {
            setLoad(add_cart_data);
        }
    }, [add_cart_data])

    const addToCartServer = async () => {
        __set('ADD_TO_CART_API_CALL');
        setAddToCartClick({ ...addToCartClick, [single_product.ItemNumber]: { clicked: true } })
        setAddToCartSingleClick({ ...addToCartSingleClick, [single_product.ItemNumber]: { clicked: true } })
        setDisableCart(ItemNumber)
        setLoad(true);

        if (disabled_add_to_cart_button) {
            setLoad(false);
            setDisableCart(0)
            __remove('ADD_TO_CART_API_CALL');
            setAddToCartClick({ ...addToCartClick, [single_product.ItemNumber]: { clicked: false } })
            return false;
        }

        setLoad(true);
        setTimeout(async () => {
            let state = store.getState();
            let isInvalidQty = state.entities.Cart.CART_BEFORE_TO_SEND_SERVER[ItemNumber].invalid_quantity;
            if (!isInvalidQty) {
                store.dispatch(SET_ADD_CART_DATA(true));
                await addToCart();
            }
            __remove('ADD_TO_CART_API_CALL');
            setAddToCartClick({ ...addToCartClick, [single_product.ItemNumber]: { clicked: false } })
            setDisableCart(0)
        }, 200);

    };


    const addToCart = async () => {
        if (single_product.ItemNumber) {
            //Added From Ramya
            localStorage.setItem("additionSrcKey", isFrom);
            let inputQty = getQuantityAddToCart();
            const productQty = get_inventory_by_distributor(single_product, single_product_inventory)

            let productParam = {
                "quantity": inputQty,
                "currency": USD,
                "cpn": "",
                "VendorCode": single_product.VendorCode,
                "SAPMatGroup": single_product.SAPMatGroup,
                "partNumber": single_product.ERPPartNumber,
                "ItemNumber": single_product.ItemNumber,
                "ManufacturerPartNumber": single_product.ManufacturerPartNumber,
                "ManufacturerCode": single_product.ManufacturerCode,
                "ManufacturerName": single_product.ManufacturerName,
                "AssetURL": single_product.AssetURL,
                "type": "Shopping",
                "ERPMFRPartNumber": single_product.ERPMFRPartNumber,
                "ERPManufacturerName": single_product.ERPManufacturerName,
                "ERPManufacturerCode": single_product.ERPManufacturerCode,
                'isSoftwareDownloadable': single_product?.SoftwareDownloadFlag,
                "addedFromBom": false,
                "default_plant": single_product.default_plant,
                "mdmMaterialId": single_product.MDMMaterialID,
                'currentStock': productQty,
                'isBackOrder': false,
                'isReplace': false,
                'seoerpmfrPartNumber': single_product?.SEOERPMFRPartNumber,
                'seoManufacturerName': single_product?.SEOManufacturerName
            }

            if (single_product?.SoftwareDownloadFlag) {
                productParam.isBackOrder = true,
                productParam.backOrderedQuantity = 0
            }

            if (CART_BEFORE_TO_SEND_SERVER[single_product.ItemNumber]?.CPN) { // need to test
                productParam.cpn = CART_BEFORE_TO_SEND_SERVER[single_product.ItemNumber]?.CPN
                productParam.endCustAccNum = get_end_customer_by_cpn(single_product.CustomerPartNumbers, CART_BEFORE_TO_SEND_SERVER[single_product.ItemNumber]?.CPN)
            }

            let data = {
                "ShortDescription": single_product?.ShortDescription,
                'ObsoleteFlag': single_product?.ObsoleteFlag,
                'EndOfLifeFlag': single_product?.EndOfLifeFlag,
                'specialPriceFlag': single_product?.specialPriceFlag,
                'constrainPartFlag': single_product?.constrainPartFlag,
                'isPartnerDistributor': single_product?.isPartnerDistributor,
                'isNewarkDistributor': single_product?.isNewarkDistributor,
                'ExcessInventoryFlag': single_product?.ExcessInventoryFlag,
                'FactoryLeadTime': single_product?.FactoryLeadTime,
                'seoerpmfrPartNumber': single_product?.SEOERPMFRPartNumber,
                'seoManufacturerName': single_product?.SEOManufacturerName
            }

            const res = await ADD_TO_CART(productParam, isFrom, data, isFromManualCart);

            if (res?.data && res?.isSuccessFull && props?.productAddedToCartCallback) {
                props.productAddedToCartCallback();

                if (isFrom === CART && !res?.data?.isBackOrderConfirmation) {
                    //added by Ramya
                    updateCartEvent(res);
                    get_Validate_Cart_From_Server({ shipToAddressId: System.getUserShippingAddress() })
                }
            }

        }
    };

    const getQuantityAddToCart = () => {
        return CART_BEFORE_TO_SEND_SERVER[ItemNumber]?.quantityUpdateToCart ? CART_BEFORE_TO_SEND_SERVER[ItemNumber].quantityUpdateToCart : 0
    };

    const getDisplayStatusOfAddToCart = () => {
        return get_display_status_button(single_product, single_product_pricing_list, single_product_inventory, 'cart')
    };
    const getDisplayStatusOfAddToQuote = () => {
        return get_display_status_button(single_product, single_product_pricing_list, single_product_inventory, 'quote')
    };
    const getDisplayStatusOfAddToQuoteLink = () => {
        return get_display_status_button(single_product, single_product_pricing_list, single_product_inventory, 'quoteLink')
    };
    const getDisplayStatusOfContactUsButton = () => {
        return get_display_status_button(single_product, single_product_pricing_list, single_product_inventory, 'contactUs')
    };
    const openContactUsPopup = (val) => {
        System.popup('ContactUsPopup', { restrict: val != undefined ? val : false, order_block: orderBlock })
    };
    const openContactPopup = (val) => {
        System.popup('ContactPopup', { isFromManualCart: true })
    };

    const openQuotePopup = () => {

        if (orderBlock) {
            openContactUsPopup(true);
            return false;
        }
        let single_product_here = produceClone(single_product);

        !liveAuth.check() ? System.popup('GuestPopupActionButton', {
            title: 'Request a Quote',
            body: 'Sign-in/Register to get a Quote',
            yesButton: 'Sign In / REGISTER', closeButton: 'cancel'
        }) :
            System.popup('QuotePopup', { single_product: single_product_here, selected_cpn: selected_cpn, single_product_pricing_list: single_product_pricing_list, addFrom: isFrom })
    };

    const customAxiosIndicatorRunTimeLoader = () => {
        return (
            load &&
            <a href={void (0)} disabled={true}
                className={!isCompactView ? "bs5 btn btn-primary btn-sm w-100 disabled" : "bs5 btn btn-primary btn-sm w-100 disabled"}>
                <i className="fa fa-spinner fa-spin" />
            </a>
        )
    };

    if (props.addToQuoteStatusCallback) {
        props.addToQuoteStatusCallback(!getDisplayStatusOfAddToCart());
    }
    const getQuoteUsButton = () => {
        if (isFrom === CART) {
            return (
                <div onClick={() => { openQuotePopup() }}>
                    <button className="bs5 btn btn-secondary btn-sm w180 h30">
                        Click To Quote
                    </button>
                </div>
            )
        }
        return (
            <button onClick={() => { openQuotePopup() }}
                className={special_class_for_add_to_quote ? special_class_for_add_to_quote + ' click-to-quote-btn' : 'bs5 btn btn-secondary w-100 click-to-quote-btn'}
            >Click To Quote
            </button>
        )
    };
    const getContactUsButton = () => {
        if (isFrom === CART) {
            return (
                <div onClick={() => { openContactPopup() }}>
                    <button className="bs5 btn btn-primary btn-sm w180 h30">
                        Contact Us
                    </button>
                </div>
            )
        }
        return (
            <button onClick={() => { openContactPopup() }}
                className={!isCompactView && !isCompactViewHide ? 'bs5 btn btn-primary w-100 click-to-quote-btn' : 'bs5 btn btn-primary click-to-quote-btn'}
            >Contact Us
            </button>
        )
    };
    
    const get_AxiosSingletonLoader_disabled_add_to_cart_button = () => {
        let flag = (single_product?.ObsoleteFlag && single_product_inventory?.quantity > 0 && (getQuantityAddToCart() > single_product_inventory?.quantity)) ? true : disabled_add_to_cart_button;
        return flag;
    };
    const axios_indicator = useSelector((state) => state.entities.system.axios_indicator);

    const result_AxiosSingletonLoader_disabled_add_to_cart_button = useMemo(() => {
        return get_AxiosSingletonLoader_disabled_add_to_cart_button();
    }, [disabled_add_to_cart_button, single_product, single_product_inventory, CART_BEFORE_TO_SEND_SERVER, axios_indicator]);

     //By Ramya Kannan [update cart - Adobe script ]
     function updateCartEvent(selectedProd){ 
        // localStorage.setItem("adobeEventType","addToCartEvent");
         let prodDetails = selectedProd?.data;
         let cartDetails = {
             "additionSource" : "cartView",
             "cartType" : "checkout"
         }
         if(Object.keys(prodDetails).length && Object.keys(cartDetails).length) {
            //  HelperAdobeEvent.trackingAdobeEvent({prodDetails,cartDetails});
            HelperAnalyticsEvent.cartEvent({ prodDetails,cartDetails });
         }
         
    }
    return (
        <div>
            {getDisplayStatusOfAddToCart() && !do_not_display_add_to_cart_button &&
                <>
                    <AxiosSingletonLoader disabled={result_AxiosSingletonLoader_disabled_add_to_cart_button}
                        slugKey={['ADD_TO_CART_API_CALL']}
                        customAxiosIndicatorRunTimeLoader={() => { return customAxiosIndicatorRunTimeLoader() }}>

                        {/* display add to cart based on active permission */}
                        {!isHideAddToCart &&
                            <>
                                {/* manually add to cart */}
                                {isFrom === CART ?
                                    <div ref={addToCartButtonRef} onClick={async () => { await addToCartServer(); }}>
                                        <button className={disabled_add_to_cart_button ? "bs5 btn btn-secondary btn-sm w180 h30 disabled" : "bs5 btn btn-secondary btn-sm w180 h30"}>
                                            UPDATE CART
                                        </button>
                                    </div>
                                    : ((__check(['ADD_TO_CART_API_CALL']).status && disableCart == ItemNumber) ?
                                        <a href={void (0)} disabled={true}
                                            className="bs5 btn btn-primary btn-sm w-100 disabled">
                                            <i className="fa fa-spinner fa-spin" />
                                        </a> :
                                        <a ref={addToCartButtonRef}
                                            onClick={async () => { await addToCartServer(); }}
                                            className={`bs5 btn btn-primary btn-sm ${isCompactView ? 'w-100 add-to-cart-icon' : "condense-add-to-cart"}`}>
                                            {isCompactView ? "" : "ADD TO"}
                                            <i className={"fa fa-shopping-cart font-14"} />
                                        </a>)
                                }
                            </>
                        }

                    </AxiosSingletonLoader>
                </>
            }

            {/* Display add to quote button based on active permission */}
            {getDisplayStatusOfAddToQuote() && getDisplayStatusOfAddToCart() === false && !isHideClickToQuote &&
                <>
                    {getQuoteUsButton()}
                </>
            }

            {/* display contact us button */}
            {getDisplayStatusOfContactUsButton() && !isHideClickToQuote &&
                <>
                    {getContactUsButton()}
                </>
            }

            {/* Display click to quote link based on active permission */}
            {getDisplayStatusOfAddToQuoteLink() && !(getDisplayStatusOfAddToQuote() && getDisplayStatusOfAddToCart() === false) && isHideClickToQuote !== true && isFrom !== CART &&
                <div className="mt-2 pt-2 click-to-quote-btn">
                    <span>{isFrom !== PDP && <>Need more?</>} <a href={void (0)}
                        className={product_detail ? "text-blue font-bold click-to-qoute-link" : "text-blue font-bold"}
                        onClick={() => {
                            openQuotePopup()
                        }}> Click to Quote</a></span>
                </div>
            }
        </div>
    );
};

export default AddToCart;